import { SentryErrorComponent } from '@components/Fallback'
import { EnginesTable } from '@features/staffMember/components/engines/EnginesTable'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { listEnginesRequestSchema } from '@customTypes/cloudmix/engine'
import { withListHydration } from '@lib/listState/withListHydration'

const StaffEnginesRoute = () => <EnginesTable />

const routerSchema = listEnginesRequestSchema.partial().catch({})
const routeId = '/_auth/staff/engines' as const

export const Route = createFileRoute(routeId)({
  component: StaffEnginesRoute,
  validateSearch: zodValidator(routerSchema),
  beforeLoad: withListHydration({
    list: { routeId },
    getTitle: () => 'Engines',
  }),
  errorComponent: SentryErrorComponent,
})
